import type {GatsbyBrowser} from 'gatsby'

import {detectPageTranslation} from '@/utils/detect-page-translation'

export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] = () => {
    detectPageTranslation()
}
